import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {selectNotifications} from '../../state/selectors/global';
import Notification from './Notification/Notification';
import {INotification} from './Notification/NotificationTypes';

const Notifications: FC = () => {
    const notifications = useSelector(selectNotifications) as INotification[];
    const dispatch = useDispatch();

    return notifications.length ? (
        <div className='absolute w-full'>
            <div className='sticky left-0 top-0 z-[200] m-auto flex justify-center p-4 md:max-w-[536px] lg:max-w-[724px] '>
                <div className='flex w-full flex-col items-center gap-3'>
                    {notifications.map((notification) => (
                        <Notification
                            dispatch={dispatch}
                            key={notification.notificationId}
                            notification={notification}
                        />
                    ))}
                </div>
            </div>
        </div>
    ) : null;
};

export default Notifications;
